import { forwardRef } from 'react';
import MuiAlert, { AlertProps as MuiAlertProps } from '@mui/material/Alert';
import { BpWarningSign, BpError, BpTickCircle, BpInfoSign } from '../Icons';

export type ControllerAlertProps = Omit<MuiAlertProps, 'iconMapping'>;

export const ControllerAlert = forwardRef<HTMLDivElement, ControllerAlertProps>(function (props, ref) {
  return (
    <MuiAlert
      {...props}
      ref={ref}
      iconMapping={{
        error: <BpError />,
        success: <BpTickCircle />,
        warning: <BpWarningSign />,
        info: <BpInfoSign />,
      }}
    />
  );
});

ControllerAlert.displayName = 'ControllerAlert';
